.pageHeader {
    background-color: #e4e9eb;
}

.pageHeaderContent {
    background-color: #e4e9eb;
    margin: auto;
    max-width: 1300px;
    padding: 20px;
}

.pageBody {
    background-color: rgba(247, 247, 247, 0.89);
    display: flex;
    flex-direction: column;
    gap: 20px;
    margin: auto;
    max-width: 1300px;
    padding: 20px;
}

.pageBodySection {
    background-color: var(--hps-white);
    border-radius: 1rem;
    height: 100%;
    padding: 20px;
    width: 100%;
}

.titleAndButtons {
    align-items: center;
    display: flex;
    justify-content: space-between;
    padding-bottom: 10px;
}

.buttons {
    display: flex;
    gap: 25px;
}
